import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useParams } from 'react-router-dom'
import { GetGroupActivities, GroupActivityRequestState } from '../../../store/GroupAction';
import * as Helper from '../../../util/Helper';
import StatusCode from '../../../util/StatusCode';
import ActiveToggle from '../../misc/ActiveToggle';
import TableHorizontalPagedToggle, { InfoObject } from '../../misc/TableHorizontalPagedToggle';
import { useTranslation } from 'react-i18next';
import { RootState } from '../../../store/store';



const GroupViewActivities = () => {
    const { t } = useTranslation(['common', 'schoolAdministration']);

    const { groupId } = useParams();
    const dispatch = useDispatch();
    const [show, setShow] = useState(true);
    const activities = useSelector<RootState, GroupActivityRequestState>(state => state.groups.activities);

    useEffect(() => {
        if (groupId !== undefined) {
            GetGroupActivities(groupId, { ...activities?.filter })(dispatch);
        }
    }, [dispatch, groupId]);

    const updateFilter = (value: boolean | number, name: string) => {
        const filter = { ...activities.filter };
        if (name === "onlyActive") {
            filter["page"] = 1;
        }
        if (groupId !== undefined) {
            GetGroupActivities(groupId, { ...filter, [name]: value })(dispatch);
        }
    }

    const mapActivities = (): InfoObject[] => {
        if (activities.code !== StatusCode.COMPLETE) {
            return [];
        }

        return activities.data.values.map(a => ({
            id: a.id,
            data: [
                { value: <Link to={`/activity/${a.id}/information`}>{a.title}</Link> },
                { value: Helper.active(a.active) },
                { value: Helper.formatDateOnly(a.startDate) },
                { value: Helper.formatDateOnly(a.endDate) },
            ]
        }));
    }

    const renderActivities = () => {
        const activitiesInfo = mapActivities();
        return (
            <TableHorizontalPagedToggle
                header={[{ value: t('genericTableHeaders.name', { ns: 'common' }) }, { value: t('genericTableHeaders.active', { ns: 'common' }) }, { value: t('genericTableHeaders.startDate', { ns: 'common' }) }, { value: t('genericTableHeaders.endDate', { ns: 'common' }) }]}
                info={activitiesInfo}
                show={show}
                toggle={() => setShow(!show)}
                onChangePage={(p) => updateFilter(p, 'page')}
                noResultMsg={t('noResult.groupActivities', { ns: 'schoolAdministration' })}
                requestState={activities}
            />
        )
    }

    const count = Helper.getTotalCountText(activities);
    return (<>
        <div className="header_member_table large">{t('object.schoolAdmin.activity_other', {ns: 'common'})} {count}
            <span className="right">
                <ActiveToggle
                    id="group-activities"
                    onlyActive={activities?.filter?.onlyActive ?? true}
                    update={(active) => updateFilter(active, 'onlyActive')}
                    disabled={activities.code === StatusCode.PENDING}
                />
            </span></div>
        {renderActivities()}
    </>);
}

export default GroupViewActivities;
